<script>
import { accountMethods } from '../state/helpers'
export default {
  props: {
    param: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...accountMethods,
  },
}
</script>

<template>
  <div v-if="actions.length" class="control position-relative d-inline float-right">
    <b-dropdown variant="link" dropright toggle-class="p-0 text-muted arrow-none">
      <template v-slot:button-content>
        <i class="uil uil-ellipsis-v font-size-14"></i>
      </template>
      <b-dropdown-item
        v-for="action in actions"
        :key="action.name"
        href="javascript: void(0);"
        @click.stop="action.method(param)"
      >
        <i :class="action.cssclass"></i>
        {{action.name}}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>